import script from "./ScoreQueryManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreQueryManagement.vue?vue&type=script&setup=true&lang=js"

import "./ScoreQueryManagement.vue?vue&type=style&index=0&id=d2c17afa&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/AIDean/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2c17afa"]])

export default __exports__